// Hooks
import { useForm, createFormContext } from '../../../hooks';

export const ResetContext = createFormContext();

export const useReset = useForm;
export default useReset;
